<template lang="pug">

  .lesson-block-franch-team-rate
    .lesson-block-franch-team-rate__header
      .lesson-block-franch-team-rate__member
        .lesson-block-franch-team-rate__member-img
          Avatar(
            :img="answer.avatar"
            circle
            size="s"
          )
        .lesson-block-franch-team-rate__member-info
          .lesson-block-franch-team-rate__member-name
            | {{answer.name}} {{answer.lastname}}
          .lesson-block-franch-team-rate__member-location
            | {{answer.city}}

      .lesson-block-franch-team-rate__stars
        .lesson-block-franch-team-rate__stars-title
          | {{typeof propAnswer.stars === 'number' || answerIsSent ? 'Вы поставили' : 'Поставить оценку'}}
        Stars(
          :propStars.sync="answer.stars"
          :answered="typeof propAnswer.stars === 'number' || answerIsSent"
        )

    TextArea.lesson-block__edit(
      v-if="typeof propAnswer.stars !== 'number' && !answerIsSent"
      title="Комментарий"
      v-model="answer.comment"
      :maxlength="1000"
      placeholder="Напишите комментарий"
      :error="$v.$dirty && !$v.answer.comment.required"
    )

    .lesson-block-franch-team-rate__comment(
      v-else
    )
      | {{answer.comment}}

    .lesson-block__buttons(
      v-if="typeof propAnswer.stars !== 'number' && !answerIsSent"
    )
      Button.-xs-(
        @click="sendAnswer"
        :isLoading="isLoading"
      )
        | Оценить

</template>

<script>
import _ from 'lodash';
import Stars from './Stars';
import { required } from 'vuelidate/lib/validators';

export default {
  components: { Stars },
  props: ['propAnswer', 'block'],
  data: () => ({
    answer: {
      userId: '',
      name: '',
      lastname: '',
      avatar: '',
      city: '',
      stars: '',
      comment: ''
    },
    isLoading: false,
    answerIsSent: false
  }),
  mounted() {
    this.answer = _.cloneDeep(this.propAnswer);
  },
  methods: {
    async sendAnswer() {
      if (this.isLoading) {
        return;
      }

      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      if (typeof this.answer.stars !== 'number') {
        this.answer.stars = 0;
      }

      this.isLoading = true;
      const res = await this.$store.dispatch('coursesLesson/sendT6V2', {
        blockId: this.block.id,
        ratedUserId: this.answer.userId,
        stars: this.answer.stars,
        comment: this.answer.comment
      });

      this.isLoading = false;
      if (res) {
        this.answerIsSent = true;
      }
    }
  },
  validations: {
    answer: {
      comment: { required }
    }
  }
};
</script>
